import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const preview_files = (
  id,
  locating,
  replace,
  subjectlocating,
  subjectreplace
) => {
  return api.post(`${ApiEndpointConstants.PREVIEWMODEL}`, {
    id,
    locating,
    replace,
    subjectlocating,
    subjectreplace,
  });
};
